<template>
  <button class="relative">
    <span
      class="icon-notification text-gray-450 text-2xl transition-300 hover:text-dark"
    />
    <span
      v-if="haveNotifications"
      :class="[
        haveNotifications > 99
          ? 'w-[22px] h-[22px] -top-1 -right-2'
          : 'w-4 h-4 top-0 -right-1',
      ]"
      class="absolute rounded-full bg-red text-white text-[10px] flex-y-center justify-center"
    >
      {{ haveNotifications }}
    </span>
  </button>
</template>

<script setup lang="ts">
interface Props {
  haveNotifications: number;
}
defineProps<Props>();
</script>

<style scoped></style>
